
export const REFERRAL_ROUTE = 'referral';
export const REFERRAL_ADD_ROUTE = 'referral/add';
export const INITIAL_REFERRAL_FRIEND_COUNT = 3;

export const REFERRAL_STATUS = {
    PENDING: 'Pending',
    CONVERTED: 'Converted',
} as const;

export type ReferralStatus = typeof REFERRAL_STATUS[keyof typeof REFERRAL_STATUS];

export const REFERRAL_STATUS_BADGE_COLORS: Record<string, string> = {
    [REFERRAL_STATUS.PENDING]: '#f57c00',
    PENDING: '#f57c00',
    [REFERRAL_STATUS.CONVERTED]: '#2e7d32',
    ACCEPTED: '#2e7d32',
};